export default "__VITE_ASSET__bWs1gK4M__"